import React from 'react';
import LiroyText from './LiroyText';
import { defaultFont } from '../../../assets/fonts/defaultFont';

export default function TextMedium80({ children, ...props }) {
    return (
        <LiroyText
            {...props}
            size={80}
            fontWeight={defaultFont.medium}
        >
            {children}
        </LiroyText>
    );
}